// variant of https://github.com/VividSeats/vivid-ui-kit/blob/main/src/components/production-near-me-row/component.tsx

import React from 'react'

import { Row, Column, Pill, Divider, Button, Text } from '@vividseats/vivid-ui-kit'
import { ProductionNearMeRowType } from '@vividseats/vivid-ui-kit/dist/components/production-near-me-row'
import classnames from 'classnames'

import HomeOpenerBadge from '../home-opener-badge'
import LowPricesDealsAvailableBadge from '../scarcity-badging/low-prices-deals-available-badge'
import SellingFastBadge from '../scarcity-badging/selling-fast-badge'

import styles from './styles.module.scss'

interface VariantProductionNearMeRowWithBadgingType extends ProductionNearMeRowType {
    isHomeOpener?: boolean
    isLowPricesDealsAvailable?: boolean
    isSellingFast?: boolean
}

const VariantProductionNearMeRowWithBadging: React.FC<VariantProductionNearMeRowWithBadgingType> = ({
    className,
    date,
    day,
    href,
    inverted,
    isHomeOpener,
    isLowPricesDealsAvailable,
    isSellingFast,
    label,
    onButtonClick,
    onClickCapture,
    pillLabel,
    sublabel,
    title,
    time,
    verticalDivider,
    ...props
}) => {
    const classNames = classnames(styles.row, className)
    const textColor = inverted ? 'inverted' : undefined

    return (
        <a {...props} onClickCapture={onClickCapture} className={styles.link} href={href}>
            <Row className={classNames}>
                {pillLabel && (
                    <Column noFlex>
                        <Column noFlex mb={0.25}>
                            <Pill importance="info" size="lg">
                                <Column noFlex>{pillLabel}</Column>
                            </Pill>
                        </Column>
                    </Column>
                )}
                <Row justify="left" align="stretch" className={styles.ticketRow}>
                    <Column noFlex className={styles.leftRail}>
                        <Text
                            size="md"
                            weight="semi-bold"
                            state={textColor}
                            className={classnames({
                                [styles.paddingTop]: isSellingFast || isLowPricesDealsAvailable || isHomeOpener,
                            })}
                        >
                            {date}
                        </Text>
                        <Column>
                            <Text size="sm" state={textColor}>
                                {day} • {time}
                            </Text>
                        </Column>
                    </Column>

                    {verticalDivider && (
                        <Column noFlex alignSelf="center">
                            <Divider size="sm" vertical />
                        </Column>
                    )}

                    <Column ml={verticalDivider ? undefined : 1}>
                        {isSellingFast ? (
                            <SellingFastBadge />
                        ) : isLowPricesDealsAvailable ? (
                            <LowPricesDealsAvailableBadge />
                        ) : isHomeOpener ? (
                            <HomeOpenerBadge />
                        ) : null}
                        <Text size="md" weight="semi-bold" state={textColor}>
                            {title}
                        </Text>
                        <Column mb={0.0625}>
                            <Text size="sm">{label}</Text>
                        </Column>
                        <Text size="sm" state={textColor} opaque>
                            {sublabel}
                        </Text>
                    </Column>
                    <Row justify="center-vertical" mobile={false}>
                        <Button onClick={onButtonClick} size="base" className={styles.ticketButton} noFill={!inverted}>
                            Find Tickets
                        </Button>
                    </Row>
                </Row>
            </Row>
        </a>
    )
}

export default VariantProductionNearMeRowWithBadging
